<template>
  <RunningCard>
    <template #header>
      <div class="running-dispatching-header">
        <div class="left">
          <div class="title">正在寻找同行乘客…</div>
          <div class="desc">
            <span>建议提前到</span>
            <span class="blue">{{ onStopName }}</span>
            <span>等候，以免错过乘</span>
          </div>
        </div>
        <img src="../../../assets/img-v2/ic_running_car.png" class="icon" />
      </div>
    </template>
    <template #content>
      <div class="running-dispatching-content">
        <div class="row">
          <img src="../../../assets/img-v2/ic_running_user.png" class="img" />
          <div class="label">{{ displayLabel }}</div>
        </div>
      </div>
    </template>
  </RunningCard>
</template>

<script>
import RunningCard from "./RunningCard.vue";

export default {
  name: "RunningDispatching",
  components: {
    RunningCard,
  },
  props: {
    orderInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    passengerCount() {
      let { singalNum = 1 } = this.orderInfo || {};
      return singalNum;
    },
    isGroupOrder() {
      const { isGroupOrder } = this.orderInfo || {};
      return isGroupOrder;
    },
    displayLabel() {
      return this.isGroupOrder ? "专车直达" : `${this.passengerCount}人乘车`;
    },
    onStopName() {
      let { onStopName = "上车站" } = this.orderInfo || {};
      return onStopName;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.running-dispatching-header {
  display: flex;
  align-items: center;
  padding: 0 10px 0 20px;
  .icon {
    width: 116px;
    height: 80px;
  }
  .left {
    flex: 1;
  }
  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 22px;
    color: #000000;
    line-height: 30px;
  }
  .desc {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 11px;
    color: rgba(0, 0, 0, 0.6);
    line-height: 16px;
    margin-top: 2px;
  }
  .blue {
    color: #006efa;
    font-weight: 500;
  }
}
.running-dispatching-content {
  padding: 20px 20px 16px 20px;
  .row {
    display: flex;
    align-items: center;
  }
  .label {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #000000;
    line-height: 16px;
  }
  .img {
    width: 16px;
    height: 16px;
  }
}
</style>
